import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/CTA.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
